import React from 'react';
import _isEmpty from 'lodash/isEmpty';

import { UiKit } from 'components';
import { useForm } from 'utils/hooks';
import { FORM_SCHEMA } from './stubs';

export default function StepOne({
  success = null,
  processing = false,
  onSubmit = () => {}
}) {
  const { data, errors, onChange } = useForm({
    dataSchema: FORM_SCHEMA,
    defaultData: { email: '' }
  });

  const onFormSubmit = e => {
    e.preventDefault();
    onSubmit({ email: data.email.toLowerCase() });
  };

  return (
    <form onSubmit={onFormSubmit}>
      <UiKit.Grid templateColumns="1fr" gap="16">
        <UiKit.Input
          type="email"
          name="email"
          value={data.email}
          onChange={value => onChange({ email: value }, false)}
          placeholder="Email"
          error={errors.email}
          disabled={success !== null || processing}
        />
        <UiKit.Button
          className="w-100"
          processing={processing}
          disabled={success !== null || !_isEmpty(errors)}
        >
          {success !== null ? 'Sent' : 'Continue'}
        </UiKit.Button>
      </UiKit.Grid>
    </form>
  );
}
